import { GeometryType } from '../types/Itinerary';
import { LatLng } from '../model/LatLng';

export function DecodePath(encoded: string, type?: GeometryType): LatLng[] {
  const len = encoded.length;
  let index = 0;
  const array: LatLng[] = [];
  let lat = 0;
  let lng = 0;
  let ele = 0;

  while (index < len) {
    let b: number;
    let shift = 0;
    let result = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
    lat += deltaLat;
    shift = 0;
    result = 0;

    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const deltaLon = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
    lng += deltaLon;

    if (type === GeometryType.TROISD) {
      shift = 0;
      result = 0;

      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);

      const deltaEle = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
      ele += deltaEle;
      array.push(new LatLng(lat * 1e-5, lng * 1e-5, ele / 100));
    } else {
      array.push(new LatLng(lat * 1e-5, lng * 1e-5));
    }
  }
  return array;
}
